import { useParams } from "react-router-dom";

export const useCampaignId = () => {
  const { campaignId } = useParams();
  return campaignId;
};
